
export default {
    props: {
        icon: {
            required: true,
            default: 'fxt-check',
            type: String
        },
        iconColor: {
            required: false,
            default: '#222222',
            type: String
        },
        backgroundColor: {
            required: false,
            default: '#ffffff',
            type: String
        },
        size: {
            required: false,
            default: '100',
            type: String
        }
    }
    
}
